module.exports = "/images/model_right_e6bd5b.png";